import styled from 'styled-components'
import { DEVICE } from '../../util/constants'
import { Link } from 'gatsby'
import { BodyCopy } from '../../components/ContentBlocks/styles/BodyContentBlock.styles'

export const HeroRegion = styled.div`
  grid-column: 2 / 3;
  display: flex;
  flex-direction: column;
`

export const ProductTitle = styled.div`
  padding-top: 24px;

  h1,
  h2 {
    font-style: normal;
    font-family: 'Open Sans', Tahoma, sans-serif;
    font-size: 3.6rem;
    line-height: 1.35;
    font-weight: 300;
    color: var(--highlight-blue);

    @media ${DEVICE.tabletL} {
      font-size: 4.8rem;
    }
    @media ${DEVICE.laptopS} {
      /* Figma: H1 Desktop Light 64 */
      font-size: 6.4rem;
    }
  }
`

export const ProductDetailRegion = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  margin-top: 20px;
  @media ${DEVICE.tabletL} {
    flex-direction: row;
  }
`

export const ProductImageContainer = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 350px;
  height: 350px;
`

export const ProductImage = styled.img`
  height: 350px;
  object-fit: none;
  object-position: center;
`

export const TextColumn = styled.div`
  margin-left: 20px;
  display: flex;
  flex-direction: column;
`

export const ProductCompany = styled.h2`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 3.6rem;
  line-height: 2;
  color: var(--content-background-dark-blue);
`

export const ProductDescriptionBox = styled(BodyCopy)`
  padding: 20px;
  max-width: 610px;
  background-color: var(--content-background-light);
`

export const BackButtonContainer = styled(Link)`
  grid-column: 2 / 3;
  grid-row: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration-line: none;
  margin-top: 41px;
  margin-bottom: 25px;

  svg {
    margin-right: 20px;
  }

  span {
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.357;
    text-transform: uppercase;
    color: var(--content-background-dark-blue);
  }

  @media ${DEVICE.tabletL} {
    span {
      font-size: 1.4rem;
    }
  }
`

export const Divider = styled.hr`
  grid-column: 2 / 3;
  margin: 60px 0;
  border: 1px solid var(--content-background-dark-blue);
`

export const MiddleGoogleAdContainer = styled.div`
  padding-bottom: 0;
  margin: 0 0 24px 0;

  @media ${DEVICE.laptopG} {
    /* margin-right: 30px; */
    /* margin-bottom: 0; */
  }
`
